import { useEffect } from "react";
import { hasOpenOverlay, hasTransientPopupOpen } from "@/hooks/useOverlayDismiss";
import { isEditableKeyboardTarget, matchesKeyboardShortcutsHelpShortcut } from "@/lib/keyboardShortcuts";

type UseKeyboardShortcutsHelpShortcutOptions = {
  onToggle: () => void;
  /** When true, allow toggle even though the shortcuts dialog registers on the overlay stack. */
  helpDialogOpen?: boolean;
  /** Compact / phone layouts omit the help catalog — skip the listener. */
  enabled?: boolean;
};

export default function useKeyboardShortcutsHelpShortcut({
  onToggle,
  helpDialogOpen = false,
  enabled = true
}: UseKeyboardShortcutsHelpShortcutOptions) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!matchesKeyboardShortcutsHelpShortcut(event)) return;
      if (isEditableKeyboardTarget(event.target)) return;
      if (!helpDialogOpen && (hasOpenOverlay() || hasTransientPopupOpen())) return;
      if (document.body.dataset.goNavMode === "true") return;

      event.preventDefault();
      onToggle();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [enabled, helpDialogOpen, onToggle]);
}
